import { Action } from '../../../../typings/permissions';
import { userHasPermissionForProject } from '../../../helpers/permissions';
import { trimString } from '../../../utils';
import { TooltipButton } from '../../generic/Button';
import Icon, { icons } from '../../generic/Icon';
import Loader from '../../generic/Loader';
import { ProjectDashboardProject, ProjectDashboardRevision, RevisionRouteParams } from '../projectDashboardTypes';

type OwnProps = {
  params: RevisionRouteParams;
  revision: ProjectDashboardRevision;
  project: ProjectDashboardProject;
  onScanIssues(ev): void;
};

const ProjectPendingScanPanel = ({
  params,
  revision,
  project,
  onScanIssues,
}: OwnProps) => {
  const canEditProject = userHasPermissionForProject(Action.Edit, project.data.locator);

  if (!revision.data.isSteady && project.data.tracking_branches.includes(params.reference)) {
    return (
      // hasn't been scanned because deep deps are still analyzing
      <div className="text-center margin-top">
        <div className="card card-primary noborder" style={{ padding: '30px 0px 30px 0px' }}>
          <Loader color="#d2b690" size={80} />
          <h3 className="nomargin-v nopadding">
            Waiting to Scan <b>{trimString(params.reference, 15)}</b>
          </h3>
          <p>FOSSA is still analyzing dependencies.</p>
          <TooltipButton
            onClick={onScanIssues}
            isDisabled={!canEditProject}
            showTooltip={!canEditProject}
            tooltip="You are not permitted to edit this project."
          >
            Skip &amp; Scan for Issues
          </TooltipButton>
        </div>
      </div>
    );
  }

  return (
    // we are not tracked or in some stalled state
    <div className="text-center margin-top">
      <div className="card noborder margin-top">
        <br />
        <span style={{ fontSize: '65px' }}>
          <Icon icon={icons.cube} />
        </span>
        <h3>Ready to Scan</h3>
        <p>
          FOSSA has discovered <b>{revision.data.license_count || '...'}</b> Licenses and<br />
          <b>{revision.data.dependency_count || '...'}</b> Dependencies in this version.
        </p>
        <TooltipButton
          type="primary"
          onClick={onScanIssues}
          isDisabled={!canEditProject}
          showTooltip={!canEditProject}
          tooltip="You are not permitted to edit this project."
        >
          <Icon icon={icons.reload} /> Run Issue Scan
        </TooltipButton>
      </div>
    </div>
  );
};

export default ProjectPendingScanPanel;
